import React, { useState } from "react";
import { useStoreState, useStoreDispatch } from "../stores/index";
import InputText from "./InputText";
import ActiveLabel from "./ActiveLabel";
import InputIncrement from "./InputIncrement";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
    "settings--list-item": {
        borderBottom: "1px solid #eee",
        composes: ["py-3"],
        "&:hover": {
            background: "#eee"
        }
    }
});

export default function SettingsDisplay() {
    const state = useStoreState();
    const dispatch = useStoreDispatch();
    const [active_input, set_active_input] = useState(null);
    const [display_form, set_display_form] = useState(false);

    const styles = useStyles();

    function handle_save(val) {
        if( !active_input || !val ) {
            return;
        }

        dispatch({
            type: "SET_CONFIG",
            payload: {
                id: active_input,
                value: val
            }
        });
        
        set_display_form(false);
        set_active_input(null);
    }

    function handle_cancel() {
        set_display_form(false);
        set_active_input(null);
    }

    function handle_active_label_click(id) {
        set_active_input(id);
        set_display_form(true);
    }

    return (
        <ul className="list-unstyled">
            <li className={styles["settings--list-item"]}>
            {   
                display_form && active_input === "workout_name"
                    ? (
                        <InputText
                            label={active_input.replace("_", " ")}
                            name={active_input}
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            placeholder={state.config[active_input]}
                            type="text"
                            value={state.config.workout_name}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("workout_name")}>
                            <span className="mr-2">
                                Workout Name:
                            </span> 
                            {state.config.workout_name}
                        </ActiveLabel>
                    )

            }
            </li>
            
            <li className={styles["settings--list-item"]}>
            {
                display_form && active_input === "warmup"
                    ? (
                        <InputIncrement
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            label="Warmup"
                            min={1}
                            max={300}
                            name={active_input}
                            value={state.config.warmup}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("warmup")}>
                            <span className="mr-2">Warmup:</span> {state.config.warmup}
                        </ActiveLabel>
                    )
            }
            </li>

            <li className={styles["settings--list-item"]}>
            {
                display_form && active_input === "intervals"
                    ? (
                        <InputIncrement
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            label="Intervals"
                            min={1}
                            max={12}
                            name={active_input}
                            value={state.config.intervals}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("intervals")}>
                            <span className="mr-2">Intervals:</span> {state.config.intervals}
                        </ActiveLabel>
                    )
            }
            </li>

            <li className={styles["settings--list-item"]}>
            {
                display_form && active_input === "work"
                    ? (
                        <InputIncrement
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            label="Work"
                            min={1}
                            max={45}
                            name={active_input}
                            value={state.config.work}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("work")}>
                            <span className="mr-2">Work:</span> {state.config.work}
                        </ActiveLabel>
                    )
            }
            </li>

            <li className={styles["settings--list-item"]}>
            {
                display_form && active_input === "rest"
                    ? (
                        <InputIncrement
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            label="Rest"
                            min={1}
                            max={45}
                            name={active_input}
                            value={state.config.rest}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("rest")}>
                            <span className="mr-2">Rest:</span> {state.config.rest}
                        </ActiveLabel>
                    )
            }
            </li>

            <li className={styles["settings--list-item"]}>
            {
                display_form && active_input === "sets"
                    ? (
                        <InputIncrement
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            label="Sets"
                            min={1}
                            max={5}
                            name={active_input}
                            value={state.config.sets}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("sets")}>
                            <span className="mr-2">Sets:</span> {state.config.sets}
                        </ActiveLabel>
                    )
            }
            </li>

            {
                state.config.sets > 1
                    ? (
                        <li className={styles["settings--list-item"]}>
                        {
                            display_form && active_input === "recovery"
                                ? (
                                    <InputIncrement
                                        handleCancel={handle_cancel}
                                        handleSave={handle_save}
                                        label="Recovery"
                                        min={1}
                                        max={120}
                                        name={active_input}
                                        value={state.config.recovery}
                                    />
                                )
                                : (
                                    <ActiveLabel handleClick={() => handle_active_label_click("recovery")}>
                                        <span className="mr-2">Recovery:</span> {state.config.recovery}
                                    </ActiveLabel>
                                )
                        }
                        </li>
                    )
                    : null
            }

            <li className={styles["settings--list-item"]}>
            {
                display_form && active_input === "cooldown"
                    ? (
                        <InputIncrement
                            handleCancel={handle_cancel}
                            handleSave={handle_save}
                            label="Cooldown"
                            min={1}
                            max={300}
                            name={active_input}
                            value={state.config.cooldown}
                        />
                    )
                    : (
                        <ActiveLabel handleClick={() => handle_active_label_click("cooldown")}>
                            <span className="mr-2">Cooldown:</span> {state.config.cooldown}
                        </ActiveLabel>
                    )
            }
            </li>
        </ul>
    );
}